import {
  GET_EXTERNAL_PROJECTS_DETIALS_LOADING,
  GET_EXTERNAL_PROJECTS_DETIALS_SUCCESS,
  GET_EXTERNAL_PROJECTS_DETIALS_FAILURE,
} from "redux/types";

const initialState = {
  projectDetailsLoading: false,
  projectDetails: null,
  errors: null,
};

export const getExternalProjectsDetailsReducer = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case GET_EXTERNAL_PROJECTS_DETIALS_LOADING:
      return { ...state, projectDetailsLoading: action.payload };
    case GET_EXTERNAL_PROJECTS_DETIALS_SUCCESS:
      return { ...state, projectDetails: action.payload };
    case GET_EXTERNAL_PROJECTS_DETIALS_FAILURE:
      return { ...state, errors: action.payload };
    default:
      return state;
  }
};
